import { useQuery } from '@tanstack/react-query';
import type { PendingPayoutsResponse } from '@evi/shared';
import { fetchPendingPayouts } from '@/lib/api';

/**
 * Pending Stripe Payouts widget data hook.
 *
 * Polling cadence — 5 minutes — matches the server-side cache
 * TTL. Polling faster wouldn't pull fresher data; the route
 * caches for 5min anyway. Stripe payout schedule is daily or
 * weekly so this is plenty fresh for the widget's purpose.
 *
 * `staleTime: 5min` deduplicates refetches across remounts (e.g.
 * toggling the widget in / out of the layout) so we don't fire
 * an API call on top of the cached server response.
 */
export function usePendingPayouts(enabled = true) {
  return useQuery<PendingPayoutsResponse>({
    queryKey: ['dashboard', 'pending-payouts'],
    queryFn: fetchPendingPayouts,
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    refetchIntervalInBackground: false,
  });
}
